/* actions/actions */
import { action } from "typesafe-actions";
import { CardTypeCodec, CardTypeActionTypes, Data } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: () => unknown | null
) => action(CardTypeActionTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data: CardTypeCodec) =>
  action(CardTypeActionTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(CardTypeActionTypes.FETCH_ERROR, error);

export const saveRequest = (
  data: {id: string, data: Data},
  callback?: (err: string | null, data: CardTypeCodec | null) => unknown
) => action(CardTypeActionTypes.SAVE_REQUEST, {data, callback});

export const saveSuccess = (data: CardTypeCodec) =>
  action(CardTypeActionTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) =>
  action(CardTypeActionTypes.SAVE_ERROR, error);
